import {FrameworkVersionId} from "platformed-client/types";
import api from "../../../api";
import {param, typedQuery} from "../../typing";

export const frameworkVersion = typedQuery(
  ["tprm", "frameworkVersion", param<FrameworkVersionId>("frameworkVersionId")],
  async frameworkVersionId => {
    return await api.tprm.frameworkVersions.get(frameworkVersionId);
  },
);

export const frameworkVersionProfiles = typedQuery(
  ["tprm", "frameworkVersionProfiles", param<FrameworkVersionId>("frameworkVersionId")],
  async frameworkVersionId => {
    return await api.tprm.frameworkVersions.listProfiles(frameworkVersionId);
  },
);

export const frameworkVersionControls = typedQuery(
  ["tprm", "frameworkVersionControls", param<FrameworkVersionId>("frameworkVersionId")],
  async frameworkVersionId => {
    return await api.tprm.frameworkVersions.listControls(frameworkVersionId);
  },
);

export const frameworkVersionModuleTemplates = typedQuery(
  ["tprm", "frameworkVersionModuleTemplates", param<FrameworkVersionId>("frameworkVersionId")],
  async frameworkVersionId => {
    return await api.tprm.frameworkVersions.listModuleTemplates(frameworkVersionId);
  },
);
